
    import './styles.scoped.css';
    export default {
  "dialog": "awsui_dialog_1d2i7_qx93j_111",
  "modal-slide-up": "awsui_modal-slide-up_1d2i7_qx93j_1",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_qx93j_1",
  "refresh": "awsui_refresh_1d2i7_qx93j_134",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_qx93j_1",
  "root": "awsui_root_1d2i7_qx93j_167",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_qx93j_1",
  "hidden": "awsui_hidden_1d2i7_qx93j_251",
  "focus-lock": "awsui_focus-lock_1d2i7_qx93j_255",
  "small": "awsui_small_1d2i7_qx93j_275",
  "medium": "awsui_medium_1d2i7_qx93j_278",
  "large": "awsui_large_1d2i7_qx93j_281",
  "max": "awsui_max_1d2i7_qx93j_284",
  "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_qx93j_284",
  "container": "awsui_container_1d2i7_qx93j_290",
  "content": "awsui_content_1d2i7_qx93j_334",
  "no-paddings": "awsui_no-paddings_1d2i7_qx93j_339",
  "header": "awsui_header_1d2i7_qx93j_344",
  "header--text": "awsui_header--text_1d2i7_qx93j_356",
  "footer": "awsui_footer_1d2i7_qx93j_360",
  "footer--stuck": "awsui_footer--stuck_1d2i7_qx93j_369",
  "dismiss-control": "awsui_dismiss-control_1d2i7_qx93j_381",
  "modal-open": "awsui_modal-open_1d2i7_qx93j_385"
};
  